import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var url = 'https://aquaminerale.eda.ru';
export default {
  name: 'Shares',
  props: {
    white: Boolean
  },
  data: function data() {
    return {
      opened: false
    };
  },
  computed: {
    color: function color() {
      if (this.white) return '#ffffff';
      return '#a28444';
    },
    shareVk: function shareVk() {
      return "https://vk.com/share.php?url=".concat(url);
    },
    shareFb: function shareFb() {
      return "https://www.facebook.com/dialog/share?app_id=1458967624164016&display=popup&href=".concat(url);
    },
    // shareTw() {
    // 	return `https://twitter.com/intent/tweet?url=${url}&text=${twitterText}`
    // },
    shareOk: function shareOk() {
      return "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=".concat(url);
    }
  },
  methods: {
    shareClick: function shareClick(soc) {
      if (window.gtag) gtag('event', "share-from: ".concat(this.$route.name, " to ").concat(soc));
    },
    openShares: function openShares() {
      if (window.innerWidth > 800) return;
      this.opened = !this.opened;
    },
    openHover: function openHover() {
      if (window.innerWidth < 800) return;
      this.opened = true;
    },
    closeHover: function closeHover() {
      if (window.innerWidth < 800) return;
      this.opened = false;
    }
  }
};